import Loader from "../../components/loader";
import { useState, useEffect } from "react";
import UiTable from "../../components/table/Table";

import paymentGateway from "./api/PaymentGateway";
import { ToastOptions } from "../../utils/constants";
import Tabledropdown from "../../components/tableDropdown/TableDropdown";
import {
  useCashIssueWithdrawList,
  useCashRedemptions,
} from "../../context/contractDataLoaderService";
import { toast } from "react-toastify";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import { useGlobal } from "../../context/globalContext";

function TradesData(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    userCountryCode,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const { data: cashRedemptions, loading: loading } = useCashRedemptions();

  const approvalRequestHeader = [
    // { label: "User ID", val: "userAddress" },
    { label: "User name", val: "userName" },
    // { label: "Payment ref", val: "requestID" },
    // { label: "Date", val: "date" },
    { label: "Currency", val: "currencySymbol" },
    { label: "Quantity", val: "amt" },
    { label: "Redemed For", val: "redeemedFor" },
    { label: "Balance", val: "balance" },
    // { label: "Status", val: "status" },
    { label: "Action", val: "action" },
  ];

  return (
    <>
      {loading ? <Loader /> : null}
      <div>
        <section className="d-flex flex-column align-items-start px-0 py-4">
          <div className="w-100">
            <h3 className="mb-3 d-flex">Withdrawal Requests</h3>
          </div>
        </section>
        <section id="requestsTable">
          <UiTable thead={approvalRequestHeader} tbodyData={cashRedemptions} />
        </section>
      </div>
    </>
  );
}

export default function ApprovalRequests(props) {
  return <TradesData {...props} />;
}
